import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import {
 setCurrentUnit, setPromotionSlug, setToken, setUser,
} from '../model/configuratorSlice';
import { EndPoints } from '../model/constants';

export default function UserService() {
    const { promotionSlug } = useParams();
    const dispatch = useDispatch();

    return useMutation(['userQuery'], (payload) => {
        const userUrl = `${EndPoints.UserUrl}/${promotionSlug}/unit/${payload.unitId}`;

        const data = {
          token: encodeURIComponent(payload.token),
        };

        axios
          .post(userUrl, data)
          .then((response) => {
            dispatch(setToken(payload.token));
            dispatch(setPromotionSlug(promotionSlug));
            dispatch(setUser(response.data));
          })
          .catch((error) => {
            dispatch(setCurrentUnit(null));
            console.log(error);
          });
    });
}
